module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.createTenantDialog.title":"Create Tenant","views.createTenantDialog.subtitle":"The tenant you create here will be charged under your current billing agreement unless other arrangements are made specifically."}}')
  delete Component.options._Ctor
}
